export default __webpack_public_path__ + "static/media/Health-Insurance.b5f1abed.png";